import {Box, HStack, Icon, Show, Text, ThemeIconKey, VStack} from 'platform/foundation';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

interface MessageRequirementItemProps extends TestIdProps {
  icon: ThemeIconKey;
  title: string;
  description?: string | Nullish;
}

export function MessageRequirementItem(props: MessageRequirementItemProps) {
  return (
    <HStack spacing={3} align="flex-start" data-testid={suffixTestId('requirementItem', props)}>
      <Box flexShrink={0} padding={2} borderRadius="medium" backgroundColor="palettes.blue.10.100">
        <Icon value={props.icon} size={5} color="severity.informational" />
      </Box>
      <VStack spacing={1}>
        <Text size="small" alternative>
          {props.title}
        </Text>
        <Show when={props.description}>
          <Text size="xSmall" color="secondary">
            {props.description}
          </Text>
        </Show>
      </VStack>
    </HStack>
  );
}
